import React from 'react';
import { Link } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';

import AccessTimeIcon from '@mui/icons-material/AccessTime';

export function Pos() {
  return (
    <div style={{ padding: '20px 20px 20px 20px' }}>
      <div className="card card-st-2">
        <div className="card-body px-4 py-4">
          <div className="text-[#2DC76D] font-bold fs-20 fw-6  mb-3">ตั้งค่า POS</div>
          <Link
            to="tag-discount"
            className="h-[89px] flex items-center justify-center text-center !rounded-lg border-0 shadow w-[114px] bg-[#FFF] text-[#2C2C2C] "
          >
            <div>
              <AccessTimeIcon className="!text-[#2DC76D] !text-[26px] " />
              <div className="text-sm text-[#2C2C2C] mt-2">Tag ส่วนลด</div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}
